<template>
  <b-modal
    id="history"
    size="lg"
    centered
    hide-footer
    hide-header
    class="p-0"
    no-close-on-backdrop
    :visible="showModal"
    @hidden="hideFeedbackhistory"
  >
    <b-overlay :show="showSpinner">
      <div class="newpanlog-rs-mainhead-1">
        <div>View Feedback History</div>
        <div @click="hideFeedbackhistory()">
          <img
            class="rotate-on-hover xmark-pos-his"
            src="../../../assets/panelist/blue_cross.svg"
            alt=""
          />
        </div>
      </div>
      <hr class="hr-jd-his" />

      <div
        class="vc-body-fd mt-3"
        v-if="feedbackHistory.length != 0 && !showSpinner"
      >
        <div
          v-for="(i, index) in feedbackHistory"
          :key="index + 'feedback'"
          class="vc-card-container mt-3"
        >
          <div
            @click.stop="toggleCollapse(index)"
            class="padding-12-20"
            :class="[
              index === activeIndex ? 'vc-open-card' : 'vc-close-card',
              'pointer',
            ]"
          >
            <div>
              <div class="vc-black-txt">Round {{ index + 1 }}</div>
            </div>
            <div class="d-flex align-items-center">
              <div class="vc-darkgrey-txt mr-3">{{ i.createdAt }}</div>
              <img
                v-if="!collapsedIndexes[index]"
                class="pointer"
                src="../../../assets/panelLog/down_arrow.svg"
                alt=""
              />
              <img
                v-else
                class="pointer"
                src="../../../assets/panelLog/dpd_open.svg"
                alt=""
              />
            </div>
          </div>
          <b-collapse v-model="collapsedIndexes[index]">
            <div class="pl-3 pr-3">
              <b-row :key="index + 'row1'" class="mt-3">
                <b-col cols="4">
                  <div
                    class="
                      pff-add-left-main-headings
                      d-flex
                      align-items-center
                      h-100
                    "
                  >
                    {{ i.recommendation == "NI" ? "Recruiter" : "Panel Name" }}
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-input
                      v-model="i.panelName"
                      :disabled="true"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row :key="index + 'row2'" class="mt-3">
                <b-col cols="4">
                  <div
                    class="
                      pff-add-left-main-headings
                      d-flex
                      align-items-center
                      h-100
                    "
                  >
                    Action
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-input
                      :placeholder="
                        showRecOptions && i.feedbackText
                          ? i.feedbackText
                          : i.recommendation == 'R'
                          ? 'Rejected'
                          : i.recommendation == 'H'
                          ? 'On-Hold'
                          : i.recommendation == 'NI'
                          ? 'Not Interested'
                          : i.recommendation == 'DNA'
                          ? 'No Show'
                          : (i.recommendation == 'S' ||
                              i.recommendation == 'FS' ||
                              i.recommendation == 'F') &&
                            i.awaitingForApproval == null
                          ? 'Selected'
                          : i.awaitingForApproval == '0' &&
                            i.recommendation == 'F'
                          ? 'Approval pending from Ops Head'
                          : ''
                      "
                      :disabled="true"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <b-row :key="index + 'row3'" class="mt-3">
                <b-col cols="4">
                  <div
                    class="
                      pff-add-left-main-headings
                      d-flex
                      align-items-center
                      h-100
                    "
                  >
                    Remarks
                  </div>
                </b-col>
                <b-col cols="8">
                  <div class="vc-input-modal d-flex align-items-center">
                    <b-form-input
                      v-model="i.recruiterRemarks"
                      :disabled="true"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>

              <div
                class="divider"
                v-if="i.botInfo && i.botInfo.botAnalysisCompleted"
              ></div>
              <section
                v-if="
                  i.botInfo &&
                  i.botInfo.botAnalysisCompleted &&
                  i.botInfo.botSummary
                "
              >
                <div>
                  <h5
                    class="
                      fw-500
                      fs-14
                      font-mont
                      color-344054
                      d-flex
                      align-items-center
                    "
                  >
                    Interview Summary
                    <img
                      src="@/assets/img/botanalysis/hire3xai.svg"
                      class="ml-2"
                      alt=""
                    />
                  </h5>
                </div>
                <p class="mt-2 fs-14 fw-500 font-mont color-darkblack">
                  {{ i.botInfo.botSummary }}
                </p>
              </section>
              <b-row class="mb-3">
                <!-- <div
                  v-if="i.panelFeedbackForm != null"
                  class="d-flex justify-content-end w-100 mt-3 p-3 pointer"
                >
                  <div
                    class="d-flex pointer"
                    @click="downloadFeedback(i.panelFeedbackForm)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/download_fdfm.svg"
                    />
                    <div class="fdbk-his-link">Feedback Form</div>
                  </div>
                </div> -->

                <!-- v-else-if="i.interviewRoundObj.id != 'F'" -->
                <div
                  v-if="
                    !i.botInfo ||
                    i.botInfo.botAnalysisCompleted == false ||
                    i.botInfo.botAnalysisCompleted == null
                  "
                  class="d-flex justify-content-end w-100 mt-3 p-3"
                >
                  <div
                    class="d-flex pointer"
                    @click.stop="assignfilledvalues(i)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/preview_eye.svg"
                    />
                    <div class="fdbk-his-link">Feedback Form</div>
                  </div>
                </div>
                <div
                  v-else-if="i.botInfo && i.botInfo.botAnalysisCompleted"
                  class="
                    mt-3
                    d-flex
                    justify-content-between
                    gap-15
                    align-items-center
                    w-100
                    mx-3
                  "
                >
                  <div
                    @click="goToBotAnalysis(i.interviewID, index)"
                    v-if="roles.includes('VIEW_CANDIDATE_ANALYSIS')"
                    class="
                      d-flex
                      w-100
                      bg-mainblue
                      viewpanel-fdbck
                      pointer
                      justify-content-center
                    "
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="@/assets/img/botanalysis/botanalysis.svg"
                    />
                    <div class="color-white fw-600 fs-13 font-mont">
                      View Bot Analysis
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      viewpanel-fdbck
                      w-100
                      pointer
                      justify-content-center
                    "
                    @click.stop="assignfilledvalues(i)"
                  >
                    <img
                      alt=""
                      class="mr-2"
                      src="../../../assets/panelLog/preview_eye.svg"
                    />
                    <div class="color-mainblue fw-600 fs-13 font-mont">
                      View Panel Feedback
                    </div>
                  </div>
                </div>
              </b-row>
            </div>
          </b-collapse>
        </div>
      </div>
      <div
        v-else-if="feedbackHistory.length == 0 && !showSpinner"
        class="modal-ht mt-5 pt-4 pr-5"
      >
        <div class="d-flex justify-content-center align-items-center">
          <img class="" src="../../../assets/panelist/nofeedback.svg" alt="" />
        </div>
        <div class="mt-3 text-center nofeedback-txt">
          Feedback is not provided for this Candidate.
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            w-100
            border-top
            bluebtn
            pt-3
            pb-1
            pl-4
            pr-4
          "
        >
          <b-button class="acs-cancelBtn-modal" @click="hideFeedbackhistory()"
            >Close</b-button
          >
        </div>
      </div>
      <PreviewFeedback
        v-if="ipmodal"
        :selectedRound="passData"
        :basicCandInfo="candidateDetails"
        :allData="allData"
        :candidateData="selectedCandidate.candidate"
        :ipmodal="ipmodal"
        :showScreenshot="true"
        :fromHistory="true"
        @closeModal="closeModal"
      />
    </b-overlay>
  </b-modal>
</template>
<script>
import { assignMarksSuccess } from "../asynchronous";
// import TotalMark from "../../../controllers/vendorCode/modals/TotalMark.vue";
import { downloadFeedback } from "../../../utils/download.js";

import { getmarksdetails } from "../../../utils/apiFunctions";
import PreviewFeedback from "../../../views/InterviewProcess/PreviewFeedback.vue";
import { mapGetters } from "vuex";

export default {
  name: "History",
  props: {
    feedbackHistory: Array,
    showSpinner: Boolean,
    context: Object,
    selectedCandidate: Object,
    showModal: Boolean,
  },
  components: {
    PreviewFeedback,
  },

  data() {
    return {
      allData: {},
      collapsedIndexes: [],
      ipmodal: false,
      activeIndex: null,
      passData: {},
      candidateDetails: {},
      vccollapse: false,

      marksdetails: {},
      dummy: {},
    };
  },
  created() {
    for (var data in this.feedbackHistory) {
      this.collapsedIndexes[data] = false;
    }
    this.collapsedIndexes[0] = true;
    this.activeIndex = 0;
  },
  computed: {
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters({ roles: "roles" }),
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
  },
  methods: {
    goToBotAnalysis(interviewID, index) {
      let queryData = {
        intid: interviewID,
        type: 1,
        fromPage: this.$route.name,
        history: true,
        candidateID: this.selectedCandidate.candidateID,
        round: index,
      };
      queryData = {
        ...queryData,
        ...this.$route.query,
      };
      delete queryData.preview;
      this.$emit("storeCandidateData");
      this.$router.push({
        name: "BotAnalysis",
        query: queryData,
      });
    },
    hideFeedbackhistory() {
      this.$emit("hideFeedbackhistory");
      if (this.$route.query.history) {
        let newQuery = { ...this.$route.query };
        delete newQuery.round;
        delete newQuery.history;
        this.$router.replace({ path: this.$route.path, query: newQuery });
      }
      this.activeIndex = null;
      this.collapsedIndexes = [];
      this.showModal = false;
      this.ipmodal = false;
      this.feedbackHistory = [];
    },
    closeModal() {
      this.ipmodal = false;
    },
    toggleCollapse(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
      this.collapsedIndexes = this.collapsedIndexes.map((value, idx) =>
        idx === index ? !value : false
      );
    },

    calculateRows(text) {
      const lineCount = text.split("\n").length;
      // Set a minimum number of rows to avoid the textarea collapsing to nothing
      const minRows = 1;
      return Math.max(minRows, lineCount);
    },
    downloadImage(url) {
      downloadFeedback(url);
    },
    downloadFeedback(url) {
      downloadFeedback(url);
    },

    // to view marks in VIEW FEEDBACK FORM HISTORY
    async assignVendorMarks(data) {
      this.context.individualMark = data;
      const res = await getmarksdetails(
        this.context.individualMark.interviewID
      );
      if (res.status == 200) {
        this.marksdetails = res.data.data;
        this.marksdetails.assessmentResponse.forEach((value, index) => {
          if (index == 0) {
            value.viewdetails = true;
          } else {
            value.viewdetails = false;
          }
        });
      }
      this.$bvModal.show("totalmark");
    },
    closeHistorymodal() {
      this.context.$bvModal.hide("history");
    },
    async assignMarksSuccess(data) {
      await assignMarksSuccess(this.context, data);
    },
    viewImage(interviee) {
      this.context.$bvModal.show("photo");
      this.context.candidateCapture = interviee;
    },
    assignfilledvalues(data) {
      this.ipmodal = true;
      this.passData = data.customFeedback;
      this.candidateDetails = data.customFeedback.basicInfo;

      // if (this.candidateDetails.modeOfInterview == "f2f") {
      //   this.candidateDetails.modeOfInterview = "Face To Face";
      // } else if (this.candidateDetails.modeOfInterview == "assesment") {
      //   this.candidateDetails.modeOfInterview = "Assesment";
      // }

      this.allData = data;
    },
  },
};
</script>
<style>
.viewpanel-fdbck {
  padding: 9px 24px;
  border: 1px solid #20639b;
  border-radius: 23px;
}
</style>
